/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ThesesTable_thesis$ref: FragmentReference;
declare export opaque type ThesesTable_thesis$fragmentType: ThesesTable_thesis$ref;
export type ThesesTable_thesis = {|
  +quick: string,
  +stock: {|
    +ticker: string,
    +name: string,
  |},
  +$refType: ThesesTable_thesis$ref,
|};
export type ThesesTable_thesis$data = ThesesTable_thesis;
export type ThesesTable_thesis$key = {
  +$data?: ThesesTable_thesis$data,
  +$fragmentRefs: ThesesTable_thesis$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ThesesTable_thesis",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quick",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Stock",
      "kind": "LinkedField",
      "name": "stock",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ticker",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Thesis",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '4f2c928ef6e3aefb55ae5f275f450d0d';

module.exports = node;
